import React, { createContext, useContext } from 'react';

export const PageHelpContext = createContext(null);

export default function PageHelpButton() {
  const help = useContext(PageHelpContext);
  if (!help) return null;
  return <button type="button" title={help.label} aria-label={help.label} onClick={help.open}
    className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-slate-300 bg-white text-sm font-semibold text-slate-600 hover:bg-slate-100">?</button>;
}
